import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { finalize } from 'rxjs/operators';
import { IdentityStorage } from 'src/app/auth/_models/identity.storage';
import { TrocaSenhaRequest } from 'src/app/model/dto/trocaSenhaRequest';
import { AdvogadoService } from 'src/app/service/advogado/advogado.service';

@Component({
  selector: 'app-trocar-senha-dialog',
  templateUrl: './trocar-senha-dialog.component.html',
  styleUrls: ['./trocar-senha-dialog.component.css']
})
export class TrocarSenhaDialogComponent implements OnInit {

  novaSenhaForm: FormGroup;
  private readonly idUser;

  constructor(private fb: FormBuilder,
    private advogadoService: AdvogadoService,
    private identityStorage: IdentityStorage,
    private toasterService: ToasterService,
    private router: Router,
    private dialogRef: MatDialogRef<TrocarSenhaDialogComponent>
  ) {
    this.idUser = identityStorage.getIdentity().id;
  }

  ngOnInit() {
    this.initFormSenha();

  }

  initFormSenha() {
    this.novaSenhaForm = this.fb.group({
      senha: ['', [Validators.required, Validators.minLength(8)]],
      repetirSenha: ['', [Validators.required, Validators.minLength(8)]],
    },
      { validator: camposIguaisValidator("senha", "repetirSenha") });
  }

  salvarSenha() {
    if (this.novaSenhaForm.invalid) return;

    const { senha } = this.novaSenhaForm.controls;

    this.advogadoService.atualizarSenha(new TrocaSenhaRequest(this.idUser, senha.value))
      .pipe(finalize(() => this.goToLoginExterno()))
      .subscribe({
        next: () => this.toasterService.pop("success", "Senha alterada com sucesso, realize uma nova autenticação."),
        error: () => this.toasterService.pop("error", "Não foi possível alterar a senha.")
      })
  }
  goToLoginExterno() {
    this.dialogRef.close();
    this.identityStorage.clearAuthData();
    this.router.navigate(['login-externo']);
  }

  getTipoError(formControl: FormControl) {
    if (!formControl || !formControl.errors) return;

    const errorType = Object.keys(formControl.errors)[0];
    const types = {
      required: "Campo obrigatório",
      minlength: "A senha deve conter 8 dígitos",
    }

    return types[errorType];
  }

  get passwordIsNotSame() {
    return this.novaSenhaForm.getError("passwordIsNotSame");
  }

}

export function camposIguaisValidator(campo1: string, campo2: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const valor1: String = formGroup.get(campo1).value;
    const valor2: String = formGroup.get(campo2).value;

    if (!valor1 || valor1.trim() === '' || !valor2 || valor2.trim() === '') return null;

    if (valor1 !== valor2) {
      return { passwordIsNotSame: true };
    }

    return null;
  };
}